import { ShoesState } from 'src/types'
import { tongueLinings, tongueLiningsWithStandingTongueAndLace } from './tongueLinings'
import { meshMaterialStandingTongue } from './meshMatrial'

const drawStandingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueFront.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(569 + x, 166 + y)
  ctx.quadraticCurveTo(595 + x, 158 + y, 613 + x, 179 + y)
  ctx.quadraticCurveTo(654 + x, 218 + y, 677 + x, 234 + y)
  ctx.quadraticCurveTo(713 + x, 224 + y, 734 + x, 201 + y)
  ctx.quadraticCurveTo(742 + x, 181 + y, 719 + x, 156 + y)
  ctx.quadraticCurveTo(685 + x, 124 + y, 669 + x, 118 + y)
  ctx.quadraticCurveTo(647 + x, 107 + y, 633 + x, 120 + y)
  ctx.quadraticCurveTo(600 + x, 137 + y, 569 + x, 166 + y)
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット
  meshMaterialStandingTongue(ctx, state, 0, 0)
}

const drawFoldingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueFront.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(416, 251)
  ctx.quadraticCurveTo(428, 265, 429, 295)
  ctx.quadraticCurveTo(432, 314, 466, 295)
  ctx.quadraticCurveTo(556, 217, 560, 202)
  ctx.quadraticCurveTo(535, 180, 535, 180)
  ctx.quadraticCurveTo(460, 210, 416, 251)
  //   ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(420, 251)
  ctx.quadraticCurveTo(432, 261, 433, 291)
  ctx.quadraticCurveTo(436, 310, 470, 285)
  ctx.quadraticCurveTo(528, 237, 555, 201)
  ctx.moveTo(424, 251)
  ctx.quadraticCurveTo(436, 261, 437, 291)
  ctx.quadraticCurveTo(444, 305, 470, 278)
  ctx.quadraticCurveTo(524, 233, 553, 197)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  ctx.lineWidth = 1.0

  //   canvasResetter(ctx) // リセット
}

export const atomsLabelOnTongue = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  if (state.atomsLabel.value === 'unselected') return
  ctx.fillStyle = '#383838'
  ctx.strokeStyle = '#383838'

  ctx.beginPath()
  ctx.moveTo(553 + x, 172 + y)
  ctx.quadraticCurveTo(551 + x, 180 + y, 563 + x, 183 + y)
  ctx.quadraticCurveTo(569 + x, 180 + y, 569 + x, 180 + y)
  ctx.quadraticCurveTo(583 + x, 171 + y, 570 + x, 171 + y)
  ctx.quadraticCurveTo(579 + x, 165 + y, 579 + x, 165 + y)
  ctx.quadraticCurveTo(599 + x, 160 + y, 595 + x, 158 + y)
  ctx.quadraticCurveTo(585 + x, 159 + y, 585 + x, 159 + y)
  ctx.quadraticCurveTo(592 + x, 149 + y, 592 + x, 149 + y)
  ctx.quadraticCurveTo(566 + x, 156 + y, 553 + x, 172 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'gold'
  ctx.beginPath()
  ctx.moveTo(558 + x, 167 + y) // 左下
  ctx.quadraticCurveTo(553 + x, 172 + y, 560 + x, 178 + y) // 右下
  ctx.quadraticCurveTo(580 + x, 174 + y, 567 + x, 174 + y) // 右下_くぼみ
  ctx.quadraticCurveTo(573 + x, 160 + y, 579 + x, 163 + y) // 右上_くぼみ
  ctx.quadraticCurveTo(592 + x, 160 + y, 592 + x, 158 + y) // 右上

  ctx.quadraticCurveTo(585 + x, 159 + y, 581 + x, 159 + y)
  ctx.quadraticCurveTo(592 + x, 149 + y, 588 + x, 148 + y)
  ctx.quadraticCurveTo(565 + x, 158 + y, 558 + x, 167 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const standingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  const tongue = state.tongue.value
  if (tongue === 'foldingTongue') return

  const openingPattern = state.openingPattern.value
  if (openingPattern === 'quarterCut') {
    tongueLiningsWithStandingTongueAndLace(ctx, state)
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueFront.color
    ctx.lineWidth = 1.0
    ctx.beginPath()
    ctx.moveTo(569, 166)
    ctx.quadraticCurveTo(595, 158, 613, 179)
    ctx.quadraticCurveTo(654, 218, 677, 234)
    ctx.quadraticCurveTo(713, 224, 734, 201)
    ctx.quadraticCurveTo(742, 181, 719, 156)
    ctx.quadraticCurveTo(685, 124, 669, 118)
    ctx.quadraticCurveTo(647, 107, 633, 120)
    ctx.quadraticCurveTo(600, 137, 569, 166)
    //   ctx.quadraticCurveTo()

    ctx.fill()
    ctx.stroke()
    ctx.closePath()
    //   canvasResetter(ctx) // リセット
    meshMaterialStandingTongue(ctx, state, 40, -28)
    atomsLabelOnTongue(ctx, state, 40, -28)
    return
  }

  if (['lowCut', 'mountainMiddleCut', 'horizontalMiddleCut'].includes(openingPattern)) {
    // 立ちベロ / 低め
    drawStandingTongue(ctx, state, -40, 30)
    tongueLinings(ctx, state, -40, 30)
    atomsLabelOnTongue(ctx, state)
  }
}
export const foldingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number): void => {
  const tongue = state.tongue.value
  if (tongue !== 'foldingTongue') return
  const openingPattern = state.openingPattern.value
  if (openingPattern === 'quarterCut') return
  if (['foldingTongue'].includes(tongue)) {
    // 折りベロ / クォーターカット以外
    drawFoldingTongue(ctx, state, 0, 0)
    atomsLabelOnTongue(ctx, state, -95, 50)
  }
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
